var app = angular.module("leonardo");

var ReportsBaseController = function($scope, $rootScope, $q, $controller, $filter, $timeout, ReportService,
                                     FilterService, AccountService, ReportFilterService) {

  $controller('TableFilterController', { $scope: $scope });
  
  $scope.reports = [];
  $scope.info_data = [];
  $scope.reportsGrouped = [];
  $scope.filters_active = [];
  $scope.groupExpanded = null;
  $scope.index_start = 0;
  $scope.index_end = 0;
  $scope.filterService = FilterService;
  $scope.reportService = ReportService;

  $scope.direct_filters = FilterService.hasFilter('direct_filters') ?
    FilterService.getFilter('direct_filters').split(',') : [];

  $timeout(function(){
    $scope.accounts = angular.copy(AccountService.getCollection());
    $scope.accounts_by_name = $filter('orderBy')($scope.accounts, 'name');
    $scope.portfolios = angular.copy(FilterService.portfolios);
    $scope.portfolios_by_name = $filter('orderBy')($scope.portfolios, 'name');
    $scope.properties = angular.copy(FilterService.properties);
    $scope.properties_by_name = $filter('orderBy')($scope.properties, 'name');
  }, 20);

  $scope.resetFields = function() {
    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else {
      var fields = [];
      angular.forEach($scope.fieldsReport, function(value) {
        fields.push(value.id);
      });
      $scope.fields_active = fields;
    }
  };

  $scope.initReport = function() {
    var title = ReportService.getTitleQuick();
    if(title !== '') {
      $scope.title = title;
      ReportService.setTitleQuick('');
    }
    $timeout(function(){
      $rootScope.$broadcast('reports:filter');
    }, 20);
  };

  $scope.groupIsExpanded = function(group) {
    return ($scope.groupExpanded === group);
  };

  $scope.toggleGroup = function(group) {
    $scope.groupExpanded = ($scope.groupExpanded === group) ? null : group;
  };

  $scope.getFieldName = function(field) {
    var name = '';
    angular.forEach($scope.fieldsReport, function(value){
      name = filterfield(field, value, name);
    });
    return name;
  };

  $scope.getDatabaseIdFieldName = function(field) {
    var name = '';
    angular.forEach($scope.IdFields, function(value){
      name = filterfield(field, value, name);
    });
    return name;
  };

  function filterfield(field, value, name){
    if (field === value.id) {
      name = value.name;
    }
    return name;
  }

  $scope.getDatabaseIdFieldValue = function(report, field) {
    switch ($scope.report_type) {
      case ReportService.TYPE_ACTION_ITEM:
        switch(field) {
          case 'property_id':
            return report.property ? report.property.id : '';
          case 'portfolio_id':
            return report.portfolio ? report.portfolio.id : '';
          case 'action_item_id':
            return report.id;
          case 'workflow_instance_id':
            return report.workflow_instance ? report.workflow_instance.id : '';
        }
        break;
      case ReportService.TYPE_PROPERTY_AMENITIES:
        switch(field) {
          case 'property_id':
            return report.property_id;
          case 'portfolio_id':
            return report.portfolio.id;
        }
        break;
      case ReportService.TYPE_PROPERTY:
        switch(field) {
          case 'property_id':
            return report.id;
          case 'portfolio_id':
            return report.portfolio ? report.portfolio.id : '';
        }
        break;
    }
  }

  $scope.getIndexUserArray = function (array, id) {
    var index = -1;
    angular.forEach(array, function (value, key) {
      index = getIndexValue(value, key, id, index);
    });
    return index;
  };

  $scope.getIndex = function(id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped, function(value, key){
      index = getIndexValue(value, key, id, index);
    });
    return index;
  };

  function getIndexValue(value, key, id, index){
    if (value.id === id) {
      index = key;
    }
    return index;
  }

  $scope.getFieldValue = function(report, field) {
    return report[field];
  };

  $scope.fillReportsGroups = function(){
    var array_by_name = null;
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        array_by_name = $scope.accounts_by_name;
        break;
      case 'portfolio':
        array_by_name = $scope.portfolios_by_name;
        break;
      case 'property':
        array_by_name = $scope.properties_by_name;
        break;
    }
    if (!$scope.next_page) {
      $scope.index_end = array_by_name.length - 1;
    }
    for(var i = $scope.index_start; i <= $scope.index_end; i++) {
      if (($scope.getIndex(array_by_name[i].id) < 0) && !_.contains($scope.info_data, array_by_name[i].id)) {
        $scope.reportsGrouped.push({id: array_by_name[i].id, reports: []});
      }
    }
    $scope.index_start = angular.copy($scope.index_end);
  };

  $scope.groupReports = function(data) {
    if (data.results){
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];
    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({id: account.id, name: account.name});
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({id: portfolio.id, name: portfolio.name});
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({id: property.id, name: property.name});
          }
        });
        break;
    }
    angular.forEach($scope.reports, function(value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              if(FilterService.hasFilter('group_reports')){
                if(_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())){
                  id.push(group.id);
                  name.push(group.name);
                  array_by_name.push({id: group.id, name: group.name});
                }
              }else{
                id.push(group.id);
                name.push(group.name);
                array_by_name.push({id: group.id, name: group.name});
              }
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({id: manager.id, name: manager.name});
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'user_role':
          if (value.account_user) {
            id = value.account_user.role;
            name = value.account_user.role;
            array_by_name = [{id: id, name: name}];
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, reports: []});
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports, value.id) === -1) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, reports: []});
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].reports, value.id) === -1) {
          $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        }
      }
    });

    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };

  $scope.getEntitiesPromise = function(options) {
    $scope.resetFields();
    angular.forEach($scope.filters_active, function(value, key) {
      options[key] = value;
    });
    var defer = $q.defer();
    ReportFilterService.filter(options, $scope.report_type).then(function (data) {
      $scope.groupReports(data);
      var results;
      if (data.results) {
        results = data.results.data ? data.results.data : data.results;
      }
      else {
        results = data;
      }
      results.meta = data.meta ? data.meta : { count: data.count };
      defer.resolve(results);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.$on('reports:updated', function(event, filters) {
    $scope.filters_active = filters;
    $scope.loadPage(1);
  });

  $timeout(function() {
    if (ReportService.getQuickReport()) {
      $scope.initReport();
    }
  }, 100);

};

app.controller('ReportsBaseController', ['$scope', '$rootScope', '$q', '$controller', '$filter', '$timeout',
  'ReportService', 'FilterService', 'AccountService', 'ReportFilterService', ReportsBaseController]);
